import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@v2/shared/lib/utils';
import useReviewStars from '@v2/shared/components/ReviewStars/useReviewStars';

type Props = {
  rating: number;
  className?: string;
};

/**
 * Five stars for a rating, and nothing else — no count, no link.
 *
 * ReviewStars is the product-page control: it always renders a "(n Reviews)" label and a
 * write-a-review affordance beside the stars, neither of which belongs on a card that
 * already carries the reviewer's name and date. The star maths is the shared hook, so
 * half stars round the same way in both places.
 */
export default function Stars({ rating, className }: Props) {
  const stars = useReviewStars(rating);

  return (
    <span
      className={cn('inline-flex gap-0.5 text-amber-500', className)}
      role="img"
      aria-label={`${rating} out of 5 stars`}
    >
      {stars.map((star, index) => (
        <FontAwesomeIcon key={index} icon={star.icon} aria-hidden />
      ))}
    </span>
  );
}
